import React from 'react';

import { ThreeSectionSliderBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpThreeSectionSliderBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<ThreeSectionSliderBlockData>) {
  return (
    <AmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        // @ts-expect-error fix me
        imageSize: data.imageSize,
        cards: data.sections.map((section) => ({
          text: section.content,
          image: section.image,
        })),
      }}
    />
  );
}
